import { useState, useMemo, useCallback } from 'react';
import { EWebclientSnippet } from '../../../constants/EWebclientSnippet';
import { toastInfoTranslated } from '../../../helpers/toast';
import { createSimpleWebclientSnippet, createAdvancedWebclientSnippet } from '../../../helpers/webclientHelper';
import { useWebclient } from './useWebclient';

export const useWebclientSnippet = () => {
  const { webclient, selectedWebclientConfig } = useWebclient();

  const [snippetType, setSnippetType] = useState<EWebclientSnippet>(EWebclientSnippet.SIMPLE);

  const snippetContent = useMemo(
    () =>
      snippetType === EWebclientSnippet.SIMPLE
        ? createSimpleWebclientSnippet(webclient, selectedWebclientConfig)
        : createAdvancedWebclientSnippet(webclient, selectedWebclientConfig),
    [snippetType, webclient, selectedWebclientConfig],
  );

  const copySnippetToClipboard = useCallback(() => {
    navigator.clipboard.writeText(snippetContent);
    toastInfoTranslated('Copied to clipboard');
  }, [snippetContent]);

  return { copySnippetToClipboard, snippetContent, snippetType, setSnippetType };
};
